import { useReactFlow } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

export function useDuplicateShortcut(onDuplicate: (ids: string[]) => void) {
  const { getNodes } = useReactFlow();
  useKeyboardShortcut(
    { key: 'd', meta: true },
    (e) => {
      // Always prevent the default browser binding (Cmd+D = Add Bookmark),
      // even if no nodes are selected — matches pre-refactor behavior.
      e.preventDefault();
      const selected = getNodes().filter((n) => n.selected).map((n) => n.id);
      if (selected.length === 0) return;
      onDuplicate(selected);
    },
  );
}
